/* eslint-disable no-unused-expressions */
import React, {Component} from 'react';
import {history} from '../helper/history';
import apis from '../helper/api';
import localdata from '../helper/localdata';
import swal from 'sweetalert';
import util from '../helper/util';
import {DatePicker, DatePickerInput} from 'rc-datepicker';
import config from '../helper/config';
import request from 'superagent';
import { NavLink } from 'react-router-dom';
import ModalProfileMaster from '../component/form/dialog_master_profile';
import Modal from 'react-responsive-modal';
import PospayLogo from '../layout/metronic/pospay-logo-color.svg';

let verification_provider = "FIREBASE" // FACEBOOK_AUTHORIZATION

class PhoneSMSToken extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sms_token: "",
            seconds: '00', 
            minutes: '00',
            disable_resend_btn: true,
            flag_processing: false,
            status_code: "Sedang mengirimkan kode verifikasi ke " + this.props.data.username + " ..."
        }
        this.secondsRemaining
        this.intervalHandle
        this.handleChange = this.handleChange.bind(this)
        this.startCountDown = this.startCountDown.bind(this)
        this.tick = this.tick.bind(this)
        this.on_submit = this.on_submit.bind(this)
        this.on_resend_token = this.on_resend_token.bind(this)
        this.on_key_press = this.on_key_press.bind(this)
    }

    componentDidMount() {
        let self = this;
        if (verification_provider === 'FIREBASE') {
            (cb => {
                const tag = document.createElement("script");
                tag.setAttribute(
                    "src",
                    "https://www.gstatic.com/firebasejs/4.3.1/firebase.js"
                );
                tag.setAttribute("id", "firebase");
                tag.setAttribute("type", "text/javascript");
                tag.onload = cb;
                document.head.appendChild(tag);
            })(() => {
                util.log("firebase initialize ...")
                var config = {
                    apiKey: "AIzaSyDyRACmhUYGGOOsb0M47xj0VmT-qFEMzFM",
                    authDomain: "",
                    databaseURL: "",
                    projectId: "posfin-30403",
                    storageBucket: "",
                    messagingSenderId: "364709568266"
                };
                window.firebase.initializeApp(config)
                self.appVerifier = new window.firebase.auth.RecaptchaVerifier("recaptcha-container", {size:"invisible"})
                let number = self.props.data.username
                if (number.startsWith("0")) {
                    number = "62" + number.substring(1, number.length)
                }
                if (!number.startsWith("+")) {
                    number = "+" + number
                }
                util.log("firebase sending code to " + number)
                window.firebase.auth().signInWithPhoneNumber(number, self.appVerifier).then(function (confirmationResult) {
                    util.log("firebase sending code result", confirmationResult)
                    window.confirmationResult = confirmationResult
                    self.setState({status_code: "Kode verifikasi sudah dikirimkan ke " + number})
                    self.startCountDown()
                }).catch(function (error) {
                    util.log("firebase error", error);
                    // self.send_sms_verification();
                });
            });
        }
    }

    
    
    componentWillUnmount() {
        clearInterval(this.intervalHandle)
    }

    handleChange(event) {
        this.setState({minutes: event.target.value})
    }

    tick() {
        var min = Math.floor(this.secondsRemaining / 60)
        var sec = this.secondsRemaining - (min * 60)
        this.setState({
            minutes: min,
            seconds: sec
        })
        if (sec < 10) {
            this.setState({seconds: "0" + this.state.seconds})
        }
        if (min < 10) {
            this.setState({minutes: "0" + min})
        }
        if (min === 0 & sec === 0) {
            this.setState({disable_resend_btn: false})
            clearInterval(this.intervalHandle)
        }
        this.secondsRemaining--
    }

    startCountDown() {
        this.setState({seconds: '00', minutes: '02'})
        this.secondsRemaining = 120
        this.intervalHandle = setInterval(this.tick, 1000)
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_key_press(e) {
        if (e.keyCode == 13) {
            if (e.target.name == "sms_token") {
                this.on_submit()
            }
        }
    }

    on_submit() {
        if (this.state.sms_token.length === 0) return
        let self = this;
        this.setState({flag_processing: true, status_code: "Verifikasi kode sedang berlangsung ..."})
        window.confirmationResult.confirm(this.state.sms_token).then(function (result) {
            var user = result.user;
            util.log("firebase verifikasi result", result);
            self.setState({flag_processing: false, status_code: "Verifikasi kode berhasil dilakukan"});
            swal({
                title: "Sukses",
                text: "Verifikasi berhasil dilakukan",
                icon: "success"
            }).then(d => {
                window.firebase.auth().currentUser.getIdToken(false).then(function(idToken) {
                    self.props.data.callback(200, idToken, self.props.data.username);
                    self.props.data.on_close();
                }).catch(function(error) {
                    util.log("firebase error get token", error)
                });
            });
        }).catch(function (error) {
            swal("Error", error.message, "error");
            self.setState({flag_processing: false, status_code: "Verifikasi kode salah"});
        });
    }

    on_resend_token() {
        let self = this
        let number = self.props.data.username
        if (number.startsWith("0")) {
            number = "62" + number.substring(1, number.length)
        }
        if (!number.startsWith("+")) {
            number = "+" + number
        }
        util.log("firebase sending code to " + number)
        self.setState({status_code: "Tunggu sebentar, sedang mengirim ulang kode verifikasi ke " + number})
        window.firebase.auth().signInWithPhoneNumber(number, this.appVerifier).then(function (confirmationResult) {
            util.log("firebase sending code result", confirmationResult)
            window.confirmationResult = confirmationResult
            self.setState({status_code: "Kode verifikasi sudah dikirimkan ke " + number})
            self.startCountDown()
        }).catch(function (error) {
            util.log("firebase error", error)
        });
    }

    render() {
        let data = this.props.data
        return (
            <Modal className="modal" open={true} center onClose={data.on_close} showCloseIcon={false} closeOnOverlayClick={false}>
                <div id="recaptcha-container"></div>
                <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width:'500px'}}>
                    <div className="modal-content" style={{border:"white"}}>
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Masukkan SMS Token
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span style={{marginBottom: '15px',display: 'block'}}>{this.state.status_code}</span>
                                    <div className="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                                        <div className="m-portlet__body">
                                            <input onChange={(e) => this.on_input_change(e)}
                                                onKeyDown={this.on_key_press}
                                                type="text"
                                                className="form-control m-input"
                                                name="sms_token"
                                                value={this.state.sms_token}
                                                placeholder="Masukkan kode verifikasi disini"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={this.on_submit} className={this.state.flag_processing ? 'btn btn-secondary btn-sm m-btn m-btn--custom m-loader m-loader--primary m-loader--right' : 'btn btn-secondary btn-sm m-btn m-btn--custom'} data-dismiss="modal">
                                Submit
                            </button>
                            <button disabled={this.state.disable_resend_btn} type="button" onClick={this.on_resend_token} className="btn btn-secondary" data-dismiss="modal">
                                Kirim Token Lagi ({this.state.minutes} : {this.state.seconds})
                            </button>
                            <button type="button" onClick={data.on_close} className="btn btn-secondary" data-dismiss="modal">
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>)
    }
}



class PhoneSMSTokenmanual extends Component {
    constructor(props) {
        super(props);
        util.log("PhoneSMSTokenmanual data:" + JSON.stringify(props));
        this.state = {
            user_id: this.props.data.user_id,
            sms_token: "",
            seconds: '00', 
            minutes: '00',
            disable_resend_btn: true,
            flag_processing: false,
            status_code: "Sedang mengirimkan kode verifikasi ke " + this.props.data.username + " ..."
        }
        this.secondsRemaining
        this.intervalHandle
        this.handleChange = this.handleChange.bind(this)
        this.startCountDown = this.startCountDown.bind(this)
        this.tick = this.tick.bind(this)
        this.on_submit = this.on_submit.bind(this)
        this.on_resend_token = this.on_resend_token.bind(this)
        this.on_key_press = this.on_key_press.bind(this)
    }

    componentDidMount() {
        let self = this; 
        let number = self.props.data.username
        if (number.startsWith("0")) {
            number = "62" + number.substring(1, number.length)
        }
        if (!number.startsWith("+")) {
            number = "+" + number
        }
        util.log("firebase sending code to " + number);
        util.log("manual sending code to " + this.state.user_id);


        let body = {
            "user_id" : this.state.user_id
        }
        request.post(apis.sms_token_resend_verification)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    swal("Ups!", "Send SMS Verification error", "warning")
                } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") { 
                            // swal("SMS Send", "Please check your message", "success");
                            self.setState({status_code: "Kode verifikasi sudah dikirimkan ke " + number})
                            self.startCountDown();
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })
    }

    
    
    componentWillUnmount() {
        clearInterval(this.intervalHandle)
    }

    handleChange(event) {
        this.setState({minutes: event.target.value})
    }

    tick() {
        var min = Math.floor(this.secondsRemaining / 60)
        var sec = this.secondsRemaining - (min * 60)
        this.setState({
            minutes: min,
            seconds: sec
        })
        if (sec < 10) {
            this.setState({seconds: "0" + this.state.seconds})
        }
        if (min < 10) {
            this.setState({minutes: "0" + min})
        }
        if (min === 0 & sec === 0) {
            this.setState({disable_resend_btn: false})
            clearInterval(this.intervalHandle)
        }
        this.secondsRemaining--
    }

    startCountDown() {
        this.setState({seconds: '00', minutes: '02'})
        this.secondsRemaining = 120
        this.intervalHandle = setInterval(this.tick, 1000)
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_key_press(e) {
        if (e.keyCode == 13) {
            if (e.target.name == "sms_token") {
                this.on_submit()
            }
        }
    }

    on_submit() {
        if (this.state.sms_token.length === 0) return
        // let self = this;
        // this.setState({flag_processing: true, status_code: "Verifikasi kode sedang berlangsung ..."})
        // window.confirmationResult.confirm(this.state.sms_token).then(function (result) {
        //     var user = result.user;
        //     util.log("firebase verifikasi result", result);
        //     self.setState({flag_processing: false, status_code: "Verifikasi kode berhasil dilakukan"});
        //     swal({
        //         title: "Sukses",
        //         text: "Verifikasi berhasil dilakukan",
        //         icon: "success"
        //     }).then(d => {
        //         window.firebase.auth().currentUser.getIdToken(false).then(function(idToken) {
        //             self.props.data.callback(200, idToken, self.props.data.username);
        //             self.props.data.on_close();
        //         }).catch(function(error) {
        //             util.log("firebase error get token", error)
        //         });
        //     });
        // }).catch(function (error) {
        //     swal("Error", error.message, "error");
        //     self.setState({flag_processing: false, status_code: "Verifikasi kode salah"});
        // });

        let self = this;
        // this.setState({flag_processing: true, status_code: "Verifikasi kode sedang berlangsung ..."})
        
        let body = {
            "user_id" : this.state.user_id,
            "verification_type" : 'SMS',
            "verification_code" : this.state.sms_token
        }
        // let self = this
        util.log("on_submit body"+JSON.stringify(body));

        request.post(apis.verification_code)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    swal("Ups!", "Register error", "warning")
                } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                           
                            // self.setState({page: 'profile-form', user_id: self.state.user_id, username: self.state.username}); 



                            // self.setState({flag_processing: false, status_code: "Verifikasi kode berhasil dilakukan"});
                                // swal({
                                //     title: "Sukses",
                                //     text: "Verifikasi berhasil dilakukan",
                                //     icon: "success"
                                // });
                            // let result = {code : 201, username: payload.results.username, user_id: payload.results.user_id, message : "next to profile"}
                            // self.props.next(result);
                            
                            // self.setState({page: 'profile-form', user_id: payload.results.user_id, username: payload.results.username});

//status, user_id, username

                            self.setState({flag_processing: false, status_code: "Verifikasi kode berhasil dilakukan"});
                                swal({
                                    title: "Sukses",
                                    text: "Verifikasi berhasil dilakukan",
                                    icon: "success"
                                }).then(d => {
                                    util.log("jalanin callback userid",self.props.data.user_id,self.props.data.username);

                                    //  self.props.data.callback(self.props.data.user_id, self.props.data.username);
                                    //  self.props.data.on_close();

                                    self.props.data.callback(201, self.props.data.username ,  self.props.data.user_id);
                                    // let result = {code : 201, username: payload.results.username, user_id: payload.results.user_id, message : "next to profile"}
                                    // self.props.next(result)

                                    self.props.data.on_close();


                                     // state.page === 'profile-form'
                                    //akan balik ke input nohp
                                    // self.setState({page: 'profile-form', user_id: payload.results.user_id, username: payload.results.username});
                                    // self.props.data.on_close();
                                });

                              

                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
        })

    }

    on_resend_token() {
        let self = this;

        let body = {
            "user_id" : this.state.user_id
        }
        request.post(apis.sms_token_resend_verification)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    swal("Ups!", "Send SMS Verification error", "warning")
                } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") { 
                            // swal("SMS Send", "Please check your message", "success");
                            self.setState({status_code: "Tunggu sebentar, sedang mengirim ulang kode verifikasi"})
                            self.startCountDown();
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })


        // util.log("firebase sending code to " + number)
        // self.setState({status_code: "Tunggu sebentar, sedang mengirim ulang kode verifikasi ke " + number})
        // this.on_submit();
    }

    render() {
        let data = this.props.data
        return (
            <Modal className="modal" open={true} center onClose={data.on_close} showCloseIcon={false} closeOnOverlayClick={false}>
                <div id="recaptcha-container"></div>
                <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width:'500px'}}>
                    <div className="modal-content" style={{border:"white"}}>
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Masukkan SMS Manual Token
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span style={{marginBottom: '15px',display: 'block'}}>{this.state.status_code}</span>
                                    <div className="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                                        <div className="m-portlet__body">
                                            <input onChange={(e) => this.on_input_change(e)}
                                                onKeyDown={this.on_key_press}
                                                type="text"
                                                className="form-control m-input"
                                                name="sms_token"
                                                value={this.state.sms_token}
                                                placeholder="Masukkan kode verifikasi disini"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={this.on_submit} className={this.state.flag_processing ? 'btn btn-secondary btn-sm m-btn m-btn--custom m-loader m-loader--primary m-loader--right' : 'btn btn-secondary btn-sm m-btn m-btn--custom'} data-dismiss="modal">
                                Submit
                            </button>
                            <button disabled={this.state.disable_resend_btn} type="button" onClick={this.on_resend_token} className="btn btn-secondary" data-dismiss="modal">
                                Kirim Token Lagi ({this.state.minutes} : {this.state.seconds})
                            </button>
                            <button type="button" onClick={data.on_close} className="btn btn-secondary" data-dismiss="modal">
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>)
    }
}

class EmailVerification extends Component {
    constructor(props) {
        super(props);
        util.log("EmailVerification data"+JSON.stringify(props));
        this.state = {
            user_id: this.props.data.user_id,
            email: this.props.data.email,
            sms_token: "",
            seconds: '00', 
            minutes: '00',
            disable_resend_btn: true,
            flag_processing: false,
            status_code: "Sedang mengirimkan OTP PIN verifikasi email ke " + this.props.data.email + " ..."
        }
        this.secondsRemaining
        this.intervalHandle
        this.handleChange = this.handleChange.bind(this)
        this.startCountDown = this.startCountDown.bind(this)
        this.tick = this.tick.bind(this)
        this.on_submit = this.on_submit.bind(this)
        this.on_resend_token = this.on_resend_token.bind(this)
        this.on_key_press = this.on_key_press.bind(this)
        
    }

    componentDidMount() {
        util.log("componentDidMount user_id"+this.state.user_id);
 
        let self = this
        let body = {
            "user_id" : this.state.user_id,
            "email" : this.state.email
        }
        request.post(apis.req_email_verification)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("req_email_verification", err)
                } else {
                    util.log("req_email_verification", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                                //  swal("Info", payload.display_message, "success");
                                 self.setState({status_code: payload.display_message})
                                 self.startCountDown();
 
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })
 
    }

    
    
    componentWillUnmount() {
        clearInterval(this.intervalHandle)
    }

    handleChange(event) {
        this.setState({minutes: event.target.value})
    }

    tick() {
        var min = Math.floor(this.secondsRemaining / 60)
        var sec = this.secondsRemaining - (min * 60)
        this.setState({
            minutes: min,
            seconds: sec
        })
        if (sec < 10) {
            this.setState({seconds: "0" + this.state.seconds})
        }
        if (min < 10) {
            this.setState({minutes: "0" + min})
        }
        if (min === 0 & sec === 0) {
            this.setState({disable_resend_btn: false})
            clearInterval(this.intervalHandle)
        }
        this.secondsRemaining--
    }

    startCountDown() {
        this.setState({seconds: '00', minutes: '02'})
        this.secondsRemaining = 120
        this.intervalHandle = setInterval(this.tick, 1000)
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_key_press(e) {
        if (e.keyCode == 13) {
            if (e.target.name == "sms_token") {
                this.on_submit()
            }
        }
    }

    on_submit() {
        if (this.state.sms_token.length === 0) return
        let self = this;
        this.setState({flag_processing: true, status_code: "Verifikasi kode sedang berlangsung ..."});
        let body = {
            "user_id" : this.state.user_id,
            "verification_code":this.state.sms_token
        }
        request.post(apis.send_email_verification)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("send_email_verification", err)
                } else {
                    util.log("send_email_verification", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            // var user = result.user;
                            util.log("isi props : ", JSON.stringify(self.props));
                            self.setState({flag_processing: false, status_code: "Verifikasi kode berhasil dilakukan"});
                            swal({
                                title: "Sukses",
                                text: "Verifikasi berhasil dilakukan",
                                icon: "success"
                            }).then(d => {
                                // window.firebase.auth().currentUser.getIdToken(false).then(function(idToken) {
                                    // self.props.data.callback(200, "", self.props.data.user_id);
                                    // self.props.data.on_close();
                                    //   self.setState({page: 'profile-form', user_id: self.props.data.user_id, username: self.props.data.username});
                                    //   AgentRegister_4.self.get_profile();
                                    // this.AgentRegister_4.get_profile();
                                    // self.props.data.on_close();npm
                                    // self.props.data.callback(self.props.data.user_id);
                                    // self.props.data.on_close();
                                    self.setState({is_email_verified:true}); 

                                    self.props.data.callback();
                                    self.props.data.on_close();

                                // }).catch(function(error) {
                                //     util.log("firebase error get token", error)
                                // });

                                // self.get_profile();
                                // self.props.data.callback(200, idToken, self.props.data.username);
                                // self.props.data.on_close();



                            });
 
                        } else {
                            swal("Ups!", payload.error.message, "warning");
                            // swal("Error", error.message, "error");
                            self.setState({flag_processing: false, status_code: "Verifikasi kode salah"});
                        }
                    }
                }
            })

 
    }

    on_resend_token() {
        // let self = this
        // let number = self.props.data.username
        // if (number.startsWith("0")) {
        //     number = "62" + number.substring(1, number.length)
        // }
        // if (!number.startsWith("+")) {
        //     number = "+" + number
        // }
        // util.log("firebase sending code to " + number)
        // self.setState({status_code: "Tunggu sebentar, sedang mengirim ulang kode verifikasi ke " + number})
        // window.firebase.auth().signInWithPhoneNumber(number, this.appVerifier).then(function (confirmationResult) {
        //     util.log("firebase sending code result", confirmationResult)
        //     window.confirmationResult = confirmationResult
        //     self.setState({status_code: "Kode verifikasi sudah dikirimkan ke " + number})
        //     self.startCountDown()
        // }).catch(function (error) {
        //     util.log("firebase error", error)
        // });



        util.log("on_resend_token user_id"+this.state.user_id);
 
        let self = this
        let body = {
            "user_id" : this.state.user_id
        }
        request.post(apis.req_email_verification)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("req_email_verification", err)
                } else {
                    util.log("req_email_verification", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                                //  swal("Info", payload.display_message, "success");
                                 self.setState({status_code: payload.display_message});
                                 self.startCountDown();
 
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })
    }

    render() {
        let data = this.props.data
        return (
            <Modal className="modal" open={true} center onClose={data.on_close} showCloseIcon={false} closeOnOverlayClick={false}>
                <div id="recaptcha-container"></div>
                <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width:'500px'}}>
                    <div className="modal-content" style={{border:"white"}}>
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Masukkan Kode PIN Email
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span style={{marginBottom: '15px',display: 'block'}}>{this.state.status_code}</span>
                                    <div className="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                                        <div className="m-portlet__body">
                                            <input onChange={(e) => this.on_input_change(e)}
                                                onKeyDown={this.on_key_press}
                                                type="text"
                                                className="form-control m-input"
                                                name="sms_token"
                                                value={this.state.sms_token}
                                                placeholder="Masukkan kode verifikasi disini"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={this.on_submit} className={this.state.flag_processing ? 'btn btn-secondary btn-sm m-btn m-btn--custom m-loader m-loader--primary m-loader--right' : 'btn btn-secondary btn-sm m-btn m-btn--custom'} data-dismiss="modal">
                                Submit
                            </button>
                            <button disabled={this.state.disable_resend_btn} type="button" onClick={this.on_resend_token} className="btn btn-secondary" data-dismiss="modal">
                                Kirim Token Lagi ({this.state.minutes} : {this.state.seconds})
                            </button>
                            <button type="button" onClick={data.on_close} className="btn btn-secondary" data-dismiss="modal">
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>)
    }
}


class AgentRegister_1 extends Component {
    constructor(props) {
        super(props)
        this.state = {flag_processing: false, nomer_hp:"", disabled: false, show_firebase_sms_token: false ,show_email_token : false,show_manual_sms_token:false}
        this.on_btn_submit_init = this.on_btn_submit_init.bind(this)
        this.on_firebase_callback = this.on_firebase_callback.bind(this)
        this.on_smsmanual_callback = this.on_smsmanual_callback.bind(this)
    }

    componentDidMount() {
        if (!window.AccountKit && verification_provider === 'FACEBOOK_AUTHORIZATION') {
            (cb => {
                const tag = document.createElement("script");
                tag.setAttribute(
                    "src",
                    "https://sdk.accountkit.com/en_US/sdk.js"
                );
                tag.setAttribute("id", "account-kit");
                tag.setAttribute("type", "text/javascript");
                tag.onload = cb;
                document.head.appendChild(tag);
            })(() => {
                window.AccountKit_OnInteractive = this.onLoad.bind(this);
            });
        }
    }

    onLoad() {
        const appId = "510061819403471"
        const csrf = "b1080c98a14b705d3ef9543a0d800a86"
        const version = "v1.1"
        const debug = false
        const display = "modal"
        const redirect = ""
        window.AccountKit.init({
            appId,
            state: csrf,
            version,
            debug,
            display,
            redirect,
            fbAppEventsEnabled: false
        });
        this.setState({
            disabled: false
        });
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_btn_submit_init() {
        if (this.state.disabled) {
            return
        }
        if (this.state.nomer_hp.length === 0) {
            return
        }
    
        let self = this
        let number = this.state.nomer_hp
        let number_reg = this.state.nomer_hp
        if (number.startsWith("0")) {
            number = number.substring(1, number.length)
            number_reg = "62" + number
            this.setState({nomer_hp: number_reg})
        } else if (number.startsWith("62")) {
            number = number.substring(2, number.length)
        }

        let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
        let body = {
            "white_label_id" : whitelabel_36,
            "username" : number_reg
        }
        this.setState({flag_processing: true})
        request.post(apis.reg_exist_username)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                    let message_result = {title: "Error", body: err.message}
                    if (res != undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                    swal(message_result.title, message_result.body, "warning")
                } else {
                    util.log(res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                         var arr = ['ACTIVE','SUSPENDED','DEACTIVATED','UNAPPROVED'];
                        //  util.log(arr.indexOf(payload.results.status) > -1);
                        if (payload.status === "OK") {
                            // swal("Ups!", "Nomor yang anda masukkan sudah terdaftar sebagai Agent dengan status " + payload.results.status + ". Silakan hubungi customer service kami untuk info lebih lanjut", "warning").then((value) => {
                                if(arr.indexOf(payload.results.status) > -1)
                                {
                                    swal("Ups!", "Nomor yang anda masukkan sudah terdaftar sebagai Agent dengan status " + payload.results.status + ". Silakan hubungi customer service kami untuk info lebih lanjut", "warning");
                                }
                                    else if (payload.results.status === 'REGISTERING') {
                                     //verication send
                                    if (verification_provider === 'FIREBASE') {
                                        let no = self.state.nomer_hp
                                        if (no.startsWith("0")) {
                                            no = "62" + no.substring(1, no.length)
                                        }                                    
                                        //send verification to sms
                                        self.setState({show_manual_sms_token:true, nomer_hp: no, user_id : payload.results.user_id })
                                    }
                                     /*

                                        let result = {code : 201, username: payload.results.username, user_id: payload.results.user_id, message : "next to profile"}
                                        self.props.next(result)*/
                                    }
                                    else if (payload.results.status === 'VERIFIED') {
                                        let result = {code : 201, username: payload.results.username, user_id: payload.results.user_id, message : "next to profile"}
                                        self.props.next(result)
                                    }
                                // })
                            self.setState({flag_processing: false})
                        } else {
                            if (payload.error.code === 2022) {
                                if (verification_provider === 'FACEBOOK_AUTHORIZATION') {
                                    const loginType = 'PHONE'
                                    const countryCode = '+62'
                                    const phoneNumber = number
                                    const options = {}
                                    if (countryCode) {
                                        options.countryCode = countryCode
                                    }
                                    if (loginType === "PHONE" && phoneNumber) {
                                        options.phoneNumber = phoneNumber
                                    }
                                    window.AccountKit.login(loginType, options, resp => self.on_account_kit_callback(resp))
                                } else if (verification_provider === 'FIREBASE') {
                                    let no = self.state.nomer_hp
                                    if (no.startsWith("0")) {
                                        no = "62" + no.substring(1, no.length)
                                    }
                                    self.setState({show_firebase_sms_token:true, nomer_hp: no})
                                }
                            } else {
                                let message_result = {title: "Error", body: res.body.error.message}
                                if (res.body.display_message !== undefined) {
                                    message_result = {title: res.body.error.message, body: res.body.display_message}
                                }
                                self.setState({flag_processing: false})
                                swal(message_result.title, message_result.body, "warning")
                            }
                        }
                    } else {
                        swal("Error", res.statusCode, "warning")
                        self.setState({flag_processing: false})
                    }
                }
            })
    }

    on_account_kit_callback(response) {
        util.log(response)
        let result = {code: 300}
        if (response !== undefined) {
            if (response.status === 'PARTIALLY_AUTHENTICATED') {
                result.code = 200
                result.token = response.code
                result.username = this.state.nomer_hp
            } else {
                result.message = response.status
                this.setState({flag_processing: false})
            }
        } else {
            result.message = "Sistem Mengalami Gangguan!"
        }
        this.props.next(result)
    }

    on_firebase_callback(status, token, number) {
        util.log("firebase callback", status, token, number)
        let result = {code:status, token:token, username:number}
        this.props.next(result)
    }
    on_smsmanual_callback(status, number, user_id) {
        util.log("on_smsmanual_callback callback", status, user_id, number)
        let result = {code:status, username:number,user_id:user_id}
        this.props.next(result)


        // let result = {code : 201, username: payload.results.username, user_id: payload.results.user_id, message : "next to profile"}
        // self.props.next(result)
    }

    // on_smsmanual_callback(user_id,username) {
    //     util.log("on_smsmanual_callback callback ",user_id,username);
 
    //     this.setState({page: 'profile-form', username: username, user_id: user_id})




    // }

    render() {
        let self = this
        const input_text_style = {padding: '1rem',fontSize: 20+'px'}
        return (
            <div className="m-login__form m-form">
                <div className="form-group">
                    <label style={{fontSize: 18+'px'}}>Masukkan Nomor Telepon:</label>
                    <input value={this.state.nomer_hp} onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" name="nomer_hp" autoComplete="off" style={input_text_style}/>
                </div>
                <div className="m-login__form-action" style={{marginTop: '5%',display: 'inline-block',textAlign: 'center',width: 100+'%'}}>
                    <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                    onClick={() => this.on_btn_submit_init()} id="m_login_signin_submit" 
                    className={this.state.flag_processing ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"}>
                        Submit untuk Verifikasi
                    </button>
                </div>
                <br/><br/>
                <div className="m-demo-icon">
                    <div className="m-demo-icon__preview">
                        <i className="la la-arrow-left"></i>
                    </div>
                    <div className="m-demo-icon__class">
                        <NavLink id="m_login_forget_password" 
                            className="m-link" 
                            to="/login" style={{fontSize:16+'px'}}>
                            Batal
                        </NavLink>
                    </div>
                </div>
                {this.state.show_firebase_sms_token? <PhoneSMSToken data={{username: this.state.nomer_hp, callback: self.on_firebase_callback, on_close: ()=>{
                    self.setState({show_firebase_sms_token: false})
                }}}/> : ''} 

                {this.state.show_manual_sms_token? <PhoneSMSTokenmanual data={{user_id: this.state.user_id, username: this.state.nomer_hp, callback: self.on_smsmanual_callback, on_close: ()=>{
                    self.setState({show_manual_sms_token: false})
                }}}/> : ''}

            </div>
        )
    }
}

class AgentRegister_2 extends Component {
    constructor(props) {
        super(props)
        this.state = {flag_processing: false, code_verification: ""}
        this.on_btn_submit_verification = this.on_btn_submit_verification.bind(this)
    }

    on_input_change(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    on_btn_submit_verification() {
        let result = {a:"eho"}
        this.props.next(result)
    }

    render() {
        let self = this
        const input_text_style = {padding: '1rem',fontSize: 20+'px'}
        return (
            <form className="m-login__form m-form" action="">
                <div className="form-group">
                    <label style={{fontSize: 18+'px'}}>Masukkan Kode Verifikasi:</label>
                    <input value={this.state.code_verification} onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" placeholder="" name="code_verification" autoComplete="off" style={input_text_style}/>
                </div>
                <div className="m-login__form-action" style={{marginTop: '5%',display: 'inline-block',textAlign: 'center',width: 100+'%'}}>
                    <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                    onClick={() => this.on_btn_submit_verification()} id="m_login_signin_submit" 
                    className={this.state.flag_processing ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"}>
                        Submit Kode Verifikasi
                    </button>
                </div>
            </form>
        )
    }
}

class AgentRegister_3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flag_processing: false, 
            flag_processing_master: false, 
            username: "", 
            master: "", 
            password: "", 
            confirm_password: "",
            type_input_password: 'password', 
            show_dialog_master: false
        };
        this.on_btn_submit_create = this.on_btn_submit_create.bind(this);
        this.master_profile = null;
        this.on_key_press = this.on_key_press.bind(this);
    }

    componentDidMount() {
        if (this.props.username) {
            this.setState({username: this.props.username});
        }
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    on_btn_submit_create() {
        let valid = true;
        let kode_master = this.state.master.trim().toLowerCase();
        let kode_master_default = config.master_referal_default.trim().toLowerCase();

        if (this.state.master.trim().length === 0) {
            kode_master = kode_master_default;
        }

        if (kode_master != kode_master_default && !this.master_profile) {
            swal("Ups!", "Pastikan kode master yang Anda masukkan valid dengan klik search disamping input kode master", "warning");
            return;
        }
        if (kode_master != kode_master_default 
            && this.master_profile 
            && kode_master != this.master_profile.master_agent_id.trim().toLowerCase()) {
            swal("Ups!", "Kode master tidak valid", "warning");
            return;
        }
        if (this.state.username.length === 0) {
            valid = false;
        }
        if (this.state.password.length === 0) {
            valid = false;
        }
        if (this.state.confirm_password.length === 0) {
            valid = false;
        }
        if (valid) {
            if (this.state.password === this.state.confirm_password) {
                let result = this.state;
                if (this.state.master.trim().length === 0) {
                    result.master = config.master_referal_default;
                }
                console.log("aaaa", result);
                this.props.next(result);
            } else {
                swal("Ups!", "Password dan Konfirm Password tidak sama", "warning");
            }
        } else {
            swal("Ups!", "Data tidak valid", "warning");
        }
    }

    on_show_hide_password(e) {
        util.log("on_show_hide_password", e);
        if (this.state.type_input_password === 'password') {
            this.setState({type_input_password: 'text'});
        } else {
            this.setState({type_input_password: 'password'});
        }
    }

    on_search_master(e) {
        util.log("on_search_master", e);
        if (this.state.flag_processing_master) return;

        let master_ref = this.state.master;
        if (master_ref.length === 0) {
            swal("Ups!", "Tidak ada master kode yang Anda masukkan", "warning");
            return;
        }
        let self = this;
        let url = apis.get_public_profile_master.replace("{whitelabel_36}", config.whitelabel.toString(36)).replace("{master_id}", master_ref);
        self.setState({flag_processing_master: true});
        request.get(url)
            .set("Content-Type", "application/json")
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("public_profile", err);
                } else {
                    util.log("public_profile", res);
                    if (res.statusCode == 200) {
                        let payload = res.body;
                        if (payload.status == "OK") {
                            if (payload.results) {
                                self.master_profile = payload.results;
                                self.setState({show_dialog_master: true});
                            }
                        } else {
                            self.master_profile = null;
                            swal("Ups!", "Tidak ada master agen dengan kode " + self.state.master, "warning");
                        }
                    } else {
                        self.master_profile = null;
                        swal("Error", res.statusCode, "error");
                    }
                }
                self.setState({flag_processing_master: false});
            })
    }

    on_key_press(e){
        if (e.keyCode == 13) {
            this.on_search_master(e);
        }
    }

    render() {
        let self = this
        const input_text_style = {padding: '1rem',fontSize: 20+'px'}
        const label_text_style = {fontSize: 18+'px'}
        
        return (
            <div className="m-login__form m-form">
                <div className="form-group">
                    <label style={label_text_style}>Username:</label>
                    <input value={this.state.username} onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" disabled name="username" autoComplete="off" style={input_text_style}/>
                </div>
                <div className="form-group">
                    <label style={label_text_style}>Kode Master Agent: (opsional)</label>
                    <div className="row col-12">
                        <div className="col-6">  <input value={this.state.master} onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" name="master" autoComplete="off" style={input_text_style} onKeyDown={this.on_key_press}/></div>
                        <div className="col-6"> <span className=" btn m-input-icon__icon m-input-icon__icon--right" style={{width: '4rem'}}>
                            {this.state.flag_processing_master ? <div className="m-loader m-loader--brand" style={{width:'30px',display:'inline-block',marginTop:'25px'}}></div> : <span onClick={(e) => this.on_search_master(e)}>
                                <button className='btn btn-primary'>Verifikasi Kode Master Agen</button>
                            </span>}
                        </span></div>
                      
                       
                    </div>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_text_style}>Password:</label>
                    <div className="m-input-icon m-input-icon--right">
                        <input value={this.state.password} onChange={(e) => this.on_input_change(e)} className="form-control m-input m-login__form-input--last" type={this.state.type_input_password} placeholder="" name="password" style={input_text_style}/>
                        <span className="m-input-icon__icon m-input-icon__icon--right" style={{width: '4rem'}}>
                            <span onClick={(e) => this.on_show_hide_password(e)}>
                                <i className={this.state.type_input_password === 'password' ? 'la la-eye' : 'la la-eye-slash'}></i>
                            </span>
                        </span>
                    </div>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_text_style}>Confirm Password:</label>
                    <div className="m-input-icon m-input-icon--right">
                        <input value={this.state.confirm_password} onChange={(e) => this.on_input_change(e)} className="form-control m-input m-login__form-input--last" type={this.state.type_input_password} placeholder="" name="confirm_password" style={input_text_style}/>
                        <span className="m-input-icon__icon m-input-icon__icon--right" style={{width: '4rem'}}>
                            <span onClick={(e) => this.on_show_hide_password(e)}>
                                <i className={this.state.type_input_password === 'password' ? 'la la-eye' : 'la la-eye-slash'}></i>
                            </span>
                        </span>
                    </div>
                </div>
                <div className="m-login__form-action" style={{marginTop: '5%',display: 'inline-block',textAlign: 'center',width: 100+'%'}}>
                    <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                    onClick={() => this.on_btn_submit_create()} id="m_login_signin_submit" 
                    className={this.state.flag_processing ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"}>
                        Register
                    </button>
                </div>
                {this.state.show_dialog_master ? <ModalProfileMaster data={this.master_profile} on_close={()=>{
                    self.setState({show_dialog_master: false})
                }} /> : ''}
            </div>
        )
    }
}

class AgentRegister_4 extends Component {
    constructor(props) {
        super(props);
        util.log("AgentRegister_4 dataprops"+JSON.stringify(props));

        this.state = {flag_processing: false, email: "", username: "",
            // identitas: [{name:"KTP"}],
            identitas_sel: "KTP", identitas_nomer: "", nomor_npwp: "", uploaded_identitas: false,
            sel_gender: "", i_tanggal_lahir: "", foto_diri: "", foto_identitas: "",
            name_full: "", email: "", fax: "", tempat_lahir: "", tanggal_lahir: "", pekerjaan: "",
            propinsi: "", kota: "", kecamatan: "", kelurahan: "", alamat: "", kode_pos: "", sel_gender: "",
            list_propinsi : [], list_kota : [], list_kecamatan : [], list_kelurahan : [],is_email_verified:false,emailstatus:"not verified"}
        this.on_btn_submit_profile = this.on_btn_submit_profile.bind(this)
        this.birth_date_change = this.birth_date_change.bind(this)
        this.on_profile_callback = this.on_profile_callback.bind(this)

    } 

    componentDidMount() {
        this.setState({user_id: this.props.user_id, username: this.props.username})
        this.load_propinsi()
        this.get_profile()
        // this.oncheckemail()
        // this.setState({identitas_sel:"KTP"});

       
    }

    // oncheckemail()
    // {
    //     util.log("oncheckemail")
    //     let status = "";
    //    {this.state.is_email_verified === false ? status = 'not verified' 
    //     : this.state.is_email_verified === true
    //     ? status = 'verified' 
    //     : this.state.is_email_verified}
    //     util.log("oncheckemail status="+status);

    //     this.setState({emailstatus:status});
    //     util.log("oncheckemail status="+this.state.emailstatus);

    // }
    
    on_profile_callback() {
     
         util.log("on_profile_callback callback")
        // let result = {user_id: this.props.user_id, username: this.props.username}
        this.get_profile();
    } 

    email_verification(email,status) {
        let self = this;
        self.setState({alamatemail:email});

        if (email.length === 0) {
            swal("Ups!", "Email Kosong, Update Profile Anda Terlebih dahulu", "warning")
            return
        }
        self.setState({show_email_token:true});
        // swal("Ups!", "data email :"+email+" data_status:"+status, "warning");

    }

    get_profile() {
        util.log("get_profile start");
        let self = this;
        util.log("get_profile data user_id:"+self.props.user_id);

        let body = {
            "user_id" : self.props.user_id
        }
        request.post(apis.reg_get_profile)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_profile", err)
                } else {
                    util.log("get_profile", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                util.log("email verified = "+payload.results.is_email_verified);
                                let results = payload.results;
                                util.log("get_profile, results = "+JSON.stringify(results));

                                // self.setState({valid_email: payload.results.is_email_verified});
                                let res = { 
                                    "name_full" : results.fullname !== null ? results.fullname : "",
                                    "email" : results.email !== null ? results.email : "",
                                    "cekemail" : results.email !== null ? results.email : "",
                                    "fax" : results.fax_number !== null ? results.fax_number : "",
                                    "tempat_lahir" : results.place_birth !== null ? results.place_birth : "",
                                    "tanggal_lahir" : results.birth_date !== null ? results.birth_date : "",
                                    "i_tanggal_lahir" : results.birth_date !== null ? results.birth_date : "",
                                    "pekerjaan" : results.job_title !== null ? results.job_title : "",
                                    "sel_gender" : results.gender !== null ? results.gender : "",
                                    "identitas_sel" : results.id_card_type !== null ? results.id_card_type : "",
                                    "identitas_nomer" : results.id_card_number !== null ? results.id_card_number : "",
                                    "nomor_npwp" : results.npwp_number !== null ? results.npwp_number : "",
                                    "propinsi" : results.province_id !== null ? results.province_id : "",
                                    "kota" : results.city_id !== null ? results.city_id : "",
                                    "kota_nama" : results.city_name !== null ? results.city_name : "",
                                    "kecamatan" : results.district_id !== null ? results.district_id : "",
                                    "kecamatan_nama" : results.district_name !== null ? results.district_name : "",
                                    "kelurahan" : results.village_id !== null ? results.village_id : "",
                                    "kelurahan_nama" : results.village_name !== null ? results.village_name : "",
                                    "alamat" : results.address !== null ? results.address : "",
                                    "kode_pos" : results.postal_code !== null ? results.postal_code : "",
                                    "foto_diri" : results.photo_filename !== null && results.photo_filename.length !== 0 ? results.photo_filename : "",
                                    "foto_identitas" : results.id_card_originalname !== null ? results.id_card_originalname : "",
                                    "is_email_verified" : results.is_email_verified !== null ? results.is_email_verified : false,
                                    //results.is_email_verified !== null ? results.is_email_verified : false
                                  
                                }
                                self.setState(res); 
                                let t = []
                                if((results.city_id !== "")&&(results.city_name !== ""))
                                {
                                    t.push({'city_id' : results.city_id, 'city_name' : results.city_name})                                
                                    self.setState({list_kota: t});
                                }
                               


                            }
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })
    }
 
    on_input_change(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    on_btn_submit_profile() {
        // util.log("on_btn_submit_profile data user_id:"+self.props.user_id);
        let valid = true
        //part identitas
        if (this.state.name_full.length === 0) {
            swal("Ups!", "Nama Anda Wajib Ada", "warning")
            return
        }

        if (this.state.identitas_nomer.length === 0) {
            swal("Ups!", "Nomor Kartu Identitas Anda Wajib Ada", "warning")
            return
        }
 
        if (this.state.nomor_npwp.length === 0) {
            swal("Ups!", "Nomor NPWP Anda Wajib Ada", "warning")
            return
        }

        // if (!this.state.nomor_npwp) {
        //     swal("Ups!", "Kartu Identitas Belum Anda Upload", "warning")
        //     return
        // }
         
        if (this.state.email.length === 0) {
            swal("Ups!", "Email Identitas Anda Wajib Ada", "warning")
            return
        }
            
        if (this.state.list_propinsi.length === 0) {
            swal("Ups!", "Data Propinsi Anda Wajib Ada", "warning")
            return
        }
        
        if (this.state.list_kota.length === 0) {
            swal("Ups!", "Data Kota Anda Wajib Ada", "warning")
            return
        }
          
        
        if (this.state.alamat.length === 0) {
            swal("Ups!", "Data Alamat Anda Wajib Ada", "warning")
            return
        }
        
        if (this.state.kode_pos.length === 0) {
            swal("Ups!", "Data KodePos Anda Wajib Ada", "warning")
            return
        }
        // if ((this.state.email.length !== 0)&&(!this.state.valid_email)) {
        //     swal("\n- Email belum tervalidasi")
        //     return
        // }
 
        // <input className={this.state.name_full.length === 0 ? "form-control m-input border-red" : "form-control m-input"} name="name_full" type="text" onChange={(e) => this.on_input_change(e)} value={this.state.name_full} style={input_text_style}/>

        // if (this.state.sel_identitas.length === 0) {
        //     swal("Ups!", "Bagian Kartu Identitas Anda Wajib Ada", "warning")
        //     return
        // }

        // if (!valid) {
        //     swal("Ups!", "Bagian Kartu Identitas Anda Wajib Ada", "warning")
        //     return
        // }
         
        if (this.state.flag_processing) return
        let self = this;
        self.setState({flag_processing: true})
        let body = {
            'user_id' : self.props.user_id,
            'fullname' : self.state.name_full,
            'email' : self.state.email,
            'fax_number' : self.state.fax,
            'place_birth' : self.state.tempat_lahir,
            'birth_date' : self.state.tanggal_lahir,
            'gender' : self.state.sel_gender,
            'npwp_number' : self.state.nomor_npwp,
            'province_id' : self.state.propinsi,
            'city_id' : self.state.kota,
            'district_id' : self.state.kecamatan,
            'village_id' : self.state.kelurahan,
            'address' : self.state.alamat,
            'postal_code' : self.state.kode_pos,
            'job_title' : self.state.pekerjaan,
            'id_card_type' : "KTP",
            'id_card_number' : self.state.identitas_nomer
        }
        util.log("on_btn_submit_profile data body:"+JSON.stringify(body));

        request.post(apis.reg_update_profile)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                let success_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res != undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status === "OK") {
                            //  self.setState({cekemail:payload.results.email,is_email_verified:payload.results.is_email_verified}); 
                            //     // self.setState({cekemail:this.state.email}); 
                                 
                            //     util.log("get_profile, res = "+JSON.stringify(res));
                            //     let t = []
                            //     // t.push({'city_id' : payload.results.city_id, 'city_name' : payload.results.city_name})                                
                            //     // self.setState({list_kota: t});
                            //     if((payload.results.city_id !== "")&&(payload.results.city_name !== ""))
                            //     {
                            //         t.push({'city_id' : payload.results.city_id, 'city_name' : payload.results.city_name})                                
                            //         self.setState({list_kota: t});
                            //     }

                            // swal("Sukses", "Berhasil Update Profile", "warning");
                            self.req_auto_approval();

                            // self.get_profile();
                            // util.log("Update Profile Success");
                            // let result = {code: 200, message: "success"}
                            //  self.props.next(result);
                            // util.log("email verified".payload.results.is_email_verified);
                            // if((payload.results.is_email_verified==false)&&(payload.results.email !== null))
                            // {
                            //     // self.send_sms_verification(payload.results.user_id);
                            //     util.log("show_email_token data user_id:"+self.props.user_id);
                            //     self.setState({show_email_token:true});
                            // }

                           
                        } else {
                            message_result = {title: "Error", body: res.body.error.message}
                            if (res.body.display_message !== undefined) {
                                message_result = {title: res.body.error.message, body: res.body.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                }
                if (message_result.length !== 0) {
                    swal(message_result.title, message_result.body, "warning")
                }
                self.setState({flag_processing: false})
            });
    }


    
    req_auto_approval() {
        let body = {
            "user_id" : this.state.user_id,
            "auto_approve": true,
            "auto_login" : true
        }
        request.post(apis.request_approval)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res != undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status === "OK") {
                            swal("Selamat Proses Registrasi berhasil. Akun Anda Telah Aktif, Silahkan Login", payload.display_message, "success").then((value) => {
                                setTimeout(() => {
                                    history.replace("/login")
                                }, 500)
                            })
                        } else {
                            message_result = {title: "Error", body: res.body.error.message}
                            if (res.body.display_message !== undefined) {
                                message_result = {title: res.body.error.message, body: res.body.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                }
                if (message_result.length !== 0) {
                    swal(message_result.title, message_result.body, "warning")
                }
            })
    }

    req_manual_approval() {
        let body = {
            "user_id" : this.state.user_id,
            "auto_approve": false,
            "auto_login" : false
        }
        request.post(apis.request_approval)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res != undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status === "OK") {
                            swal("Selamat!", payload.display_message, "warning").then((value) => {
                                setTimeout(() => {
                                    history.replace("/login")
                                }, 500)
                            })
                        } else {
                            message_result = {title: "Error", body: res.body.error.message}
                            if (res.body.display_message !== undefined) {
                                message_result = {title: res.body.error.message, body: res.body.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                }
                if (message_result.length !== 0) {
                    swal(message_result.title, message_result.body, "warning")
                }
            })
    }


    on_select_change(e) {
        let self = this
        util.log(e.target.id + " . " + e.target.value)
        if (e.target.id === 'propinsi-sel') {
            self.setState({list_kota: [], list_kecamatan: [], list_kelurahan: [], propinsi: e.target.value})
            if (e.target.value.length !== 0) {
                let url = apis.list_kota.replace("{provinsi_id}", e.target.value)
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'city_id' : item.city_id, 'city_name' : item.city_name})
                                )
                                self.setState({list_kota: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kota-sel') {
            self.setState({list_kecamatan: [], list_kelurahan: [], kota: e.target.value})
            if (e.target.value.length !== 0) {
                let url = apis.list_district.replace("{provinsi_id}", self.state.propinsi).replace("{kota_id}", e.target.value)
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'district_id' : item.district_id, 'district_name' : item.district_name})
                                )
                                self.setState({list_kecamatan: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kecamatan-sel') {
            self.setState({list_kelurahan: [], kecamatan: e.target.value})
            if (e.target.value.length !== 0) {
                let url = apis.list_village.replace("{provinsi_id}", self.state.propinsi).replace("{kota_id}", self.state.kota).replace("{district_id}", e.target.value)
                request.get(url).end((err, res) => {
                    if (err) {
                        util.log("error: " + err);
                    } else {
                        util.log(res);
                        if (res.status == 200) {
                            const data = JSON.parse(res.text)
                            if (data.status == "OK") {
                                let list = data.results.list
                                let t = []
                                list.map(item =>
                                    t.push({'village_id' : item.village_id, 'village_name' : item.village_name})
                                )
                                self.setState({list_kelurahan: t})
                            }
                        }
                    }
                })
            }
        } else if (e.target.id === 'kelurahan-sel') {
            self.setState({kelurahan: e.target.value})
        } else if (e.target.id === 'gender-sel') {
            self.setState({sel_gender: e.target.value})
        } 
        // else if (e.target.id === 'identitas-sel') {
        //     self.setState({sel_identitas: e.target.value})
        // }
    }

    load_propinsi() {
        let self = this
        request.get(apis.list_propinsi).end((err, res) => {
            if (err) {
                util.log("error: " + err);
            } else {
                util.log(res);
                if (res.status == 200) {
                    const data = JSON.parse(res.text)
                    if (data.status == "OK") {
                        let list = data.results.list
                        let t = []
                        list.map(item =>
                            t.push({'province_id' : item.province_id, 'province_name' : item.province_name})
                        )
                        self.setState({list_propinsi: t})
                    }
                }
            }
        })
    }

    photo_input_changed = (event) => {
        let upload_img = event.target.files[0]
        util.log(upload_img)
        if (upload_img === undefined) { return }
        let self = this
        if (upload_img.type === "image/jpeg" || upload_img.type === "image/png") {
            this.setState({foto_diri: upload_img.name})
            request.post(apis.reg_upload_photo)
                .attach('fileupload', upload_img)
                .field('user_id', self.props.user_id)
                .then(res => {
                    util.log(res)
                    if (res.ok) {
                        let failed = ""
                        if (res.statusCode === 200) {
                            let payload = res.body
                            if (payload.status === "OK") {
                                swal("Sukses", "Berhasil upload foto", "warning")
                            } else {
                                failed = payload.error.message
                            }
                        } else {
                            failed = res.statusCode
                        }
                        if (failed.length !== 0) {
                            swal("Gagal Upload", failed, "warning")
                        }
                    }
                })
        } else {
            return swal("Ups !", "Hanya boleh file gambar", "warning")
        }
    }

    kartu_identitas_input_changed = (event) => {
        let upload_img = event.target.files[0]
        util.log(upload_img)
        if (upload_img === undefined) { return }
        let self = this
        if (upload_img.type === "image/jpeg" || upload_img.type === "image/png") {
            this.setState({foto_identitas: upload_img.name})
            request.post(apis.reg_upload_kartu_identitas)
                .attach('fileupload', upload_img)
                .field('user_id', self.props.user_id)
                .then(res => {
                    util.log(res)
                    if (res.ok) {
                        let failed = ""
                        if (res.statusCode === 200) {
                            let payload = res.body
                            if (payload.status === "OK") {
                                swal("Sukses", "Berhasil upload kartu identitas", "warning")
                                self.setState({uploaded_identitas: true})
                            } else {
                                failed = payload.error.message
                            }
                        } else {
                            failed = res.statusCode
                        }
                        if (failed.length !== 0) {
                            swal("Gagal Upload", failed, "warning")
                        }
                    }
                })
        } else {
            return swal("Ups!", "Hanya boleh file gambar", "warning")
        }
    }

    birth_date_change(date) {
        try {
            util.log(date)
            let onlyDate = ''
            if (date.length !== 0) {
                let bulan = (date.getMonth() + 1).toString()
                let hari = date.getDate().toString()
                let m = bulan.length === 1 ? '0' + bulan : bulan
                let h = hari.length === 1 ? '0' + hari : hari
                onlyDate = date.getFullYear() + "-" + m + "-" + h
            }
            util.log(onlyDate)
            this.setState({tanggal_lahir : onlyDate, i_tanggal_lahir : date});
        } catch(err) {
            util.log("[end_date_change] error", err)
        }
    }

    render() {
        let self = this
        const label_input_style = {fontSize: 16+'px'}
        const input_text_style = {padding: '1rem',fontSize: 20+'px'}
        const input_file_style = {width: '8rem',display: 'inline-flex',margin: '7px',height: 'unset',cursor: 'pointer',backgroundColor: 'cadetblue',padding: '10px 15px',borderRadius: '5px'}
        return (
            <div className="m-login__form m-form">
                <div className="form-group">
                    <h3 className="m-form__section" style={{fontSize: 22+'px'}}>
                        1. Kartu Identitas 
                    </h3>
                </div>
                <div className="form-group">
                    <label style={label_input_style}>
                        Tipe Kartu Identitas:  KTP
                    </label>
                    {/* <select className="form-control m-input" id="identitas-sel" value={this.state.sel_identitas} onChange={(e) => this.on_select_change(e)} style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}> */}
{/* 
                    <input className="form-control m-input" type="hidden" name="identitas_sel"  
                        value={this.state.identitas_sel} style={input_text_style} /> */}


                    {/* <select className="form-control m-input" name="identitas_sel" value={this.state.identitas_sel}  style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}>
                        <option value="KTP"> KTP </option>
                        {
                            self.state.identitas.length != 0 ? self.state.identitas.map((p, i) =>
                                <option key={i} value={p.name}>
                                    {p.name}
                                </option>
                            ) : ''
                        }
                    </select> */}
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Nomor (Sesuai Kartu Identitas): <span className='text-danger'>*</span> 
                    </label>
                    <input className={this.state.identitas_nomer.length === 0 ? "form-control m-input border-red" : "form-control m-input"} type="number" name="identitas_nomer" onChange={(e) => this.on_input_change(e)}
                        value={this.state.identitas_nomer} style={input_text_style} maxLength="16"
                        onInput = {(e) =>{
                            e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,16)
                          }}
                        />
                </div>
                <div className="form-group">
                    <label style={label_input_style}>
                        Nama (Sesuai Kartu Identitas): <span className='text-danger'>*</span> 
                    </label>
                    <input className={this.state.name_full.length === 0 ? "form-control m-input border-red" : "form-control m-input"} name="name_full" type="text" onChange={(e) => this.on_input_change(e)} value={this.state.name_full} style={input_text_style}/>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Foto Kartu Identitas: <span className='text-danger'>*</span> 
                    </label>
                    <div className="m-input-icon m-input-icon--right">
                        <input disabled className={this.state.foto_identitas.length === 0 ? "form-control m-input border-red" : "form-control m-input"} type="text" name="foto_identitas" value={this.state.foto_identitas} style={input_text_style}/>
                        <span className="m-input-icon__icon m-input-icon__icon--right" style={input_file_style} onClick={(e) => document.getElementById("upload_identitas").click()} >
                            <i className='la la-cloud-upload' style={{color: 'white', fontWeight: '600'}}></i>
                            <span style={{color: 'white', fontWeight: '600'}}>
                                Upload
                            </span>
                        </span>
                    </div>
                    <input className="form-control m-input" type="file" id="upload_identitas" name="upload_identitas" onChange={this.kartu_identitas_input_changed}
                        style={{display:'none'}}/>
                </div>
                <div className="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                <div className="form-group">
                    <h3 className="m-form__section" style={{fontSize: 22+'px'}}>
                        2. Personal Info  
                    </h3>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        NPWP: <span className='text-danger'>*</span>
                    </label> 

                    <input className={this.state.nomor_npwp.length === 0 ? "form-control m-input border-red" : "form-control m-input"} type="number" name="nomor_npwp" onChange={(e) => this.on_input_change(e)}
                        value={this.state.nomor_npwp} style={input_text_style}
                        onInput = {(e) =>{
                            e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,16)
                          }}
                          />
                        <span className='small'> (dapat diisi dengan NIK jika sudah memadankan NPWP)</span>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Email: <span className='text-danger'>*</span>  ({this.state.is_email_verified === false ? 'not verified' 
                                    : this.state.is_email_verified === true
                                    ?   'verified' 
                                    : this.state.is_email_verified})
                    </label>

                    <input className={this.state.email.length === 0 ? "form-control m-input border-red" : "form-control m-input"}  type="text" name="email" onChange={(e) => this.on_input_change(e)}
                        value={this.state.email} style={input_text_style} disabled={this.state.is_email_verified}
                        /> 


                    {(this.state.is_email_verified === false) ?    <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                                        onClick={() => this.email_verification(this.state.email,this.state.is_email_verified)} id="m_login_signin_submit" 
                                        className=  "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn" >Verifikasi Email</button> : ''  }

                    
                         
 
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Jenis Kelamin:
                    </label>
                    <select className="form-control m-input" id="gender-sel" value={this.state.sel_gender} onChange={(e) => this.on_select_change(e)} style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}>
                        <option key={999} value=""> -- Pilih -- </option>
                        <option key={0} value="M">Laki-Laki</option>
                        <option key={1} value="F">Perempuan</option>
                    </select>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Fax:
                    </label>
                    <input className="form-control m-input" type="text" name="fax" onChange={(e) => this.on_input_change(e)}
                        value={this.state.fax} style={input_text_style}/>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Tempat Lahir:
                    </label>
                    <input className="form-control m-input"  type="text" name="tempat_lahir" onChange={(e) => this.on_input_change(e)}
                        value={this.state.tempat_lahir} style={input_text_style}/>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Tanggal Lahir:
                    </label>
                    <DatePickerInput onChange={this.birth_date_change} value={this.state.i_tanggal_lahir}/>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Pekerjaan:
                    </label>
                    <input className="form-control m-input"  type="text" name="pekerjaan" onChange={(e) => this.on_input_change(e)}
                        value={this.state.pekerjaan} style={input_text_style}/>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Foto Diri:
                    </label>
                    <div className="m-input-icon m-input-icon--right">
                        <input disabled className="form-control m-input" type="text" name="foto_diri" value={this.state.foto_diri} style={input_text_style}/>
                        <span className="m-input-icon__icon m-input-icon__icon--right" style={input_file_style} onClick={(e) => document.getElementById("upload_foto_diri").click()} >
                            <i className='la la-cloud-upload' style={{color: 'white', fontWeight: '600'}}></i>
                            <span style={{color: 'white', fontWeight: '600'}}>
                                Upload
                            </span>
                        </span>
                    </div>
                    <input className="form-control m-input" type="file" id="upload_foto_diri" name="upload_foto_diri" onChange={this.photo_input_changed} style={{display: 'none'}}/>
                </div>
                <div className="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                <div className="form-group">
                    <h3 className="m-form__section" style={{fontSize: 22+'px'}}>
                        3. Alamat Domisili
                    </h3>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Provinsi: <span className='text-danger'>*</span>
                    </label>
                    <select className={this.state.list_propinsi.length === 0 ? "form-control m-input border-red" : "form-control m-input"}  id="propinsi-sel" value={this.state.propinsi} onChange={(e) => this.on_select_change(e)} style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}>
                        <option key={999} value=""> -- Pilih Provinsi -- </option>
                        {
                            self.state.list_propinsi.length != 0 ? self.state.list_propinsi.map((item, i) =>
                                <option key={i} value={item.province_id}>
                                    {item.province_name}
                                </option>
                            ) : ''
                        }
                    </select>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Kota: <span className='text-danger'>*</span>
                    </label>
                    <select className={this.state.list_kota.length === 0 ? "form-control m-input border-red" : "form-control m-input"}  id="kota-sel" value={this.state.kota} onChange={(e) => this.on_select_change(e)} style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}>
                        <option key={999} value=""> -- Pilih Kota -- </option>
                        {
                            self.state.list_kota.length != 0 ? self.state.list_kota.map((item, i) =>
                                <option key={i} value={item.city_id}>
                                    {item.city_name}
                                </option>
                            ) : ''
                        }
                    </select>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Kecamatan:
                    </label>
                    <select className="form-control m-input"  id="kecamatan-sel" value={this.state.kecamatan} onChange={(e) => this.on_select_change(e)} style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}>
                        <option key={999} value=""> -- Pilih Kecamatan -- </option>
                        {
                            self.state.list_kecamatan.length != 0 ? self.state.list_kecamatan.map((item, i) =>
                                <option key={i} value={item.district_id}>
                                    {item.district_name}
                                </option>
                            ) : ''
                        }
                    </select>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Kelurahan:
                    </label>
                    <select className="form-control m-input"  id="kelurahan-sel" value={this.state.kelurahan} onChange={(e) => this.on_select_change(e)} style={{height: 4+'rem',MozAppearance: 'none',WebkitAppearance: 'none',fontSize: 20+'px'}}>
                        <option key={999} value=""> -- Pilih Kelurahan -- </option>
                        {
                            self.state.list_kelurahan.length != 0 ? self.state.list_kelurahan.map((item, i) =>
                                <option key={i} value={item.village_id}>
                                    {item.village_name}
                                </option>
                            ) : ''
                        }
                    </select>
                </div>
                <div className="form-group">
                    <label style={label_input_style}>
                        Alamat Lengkap: <span className='text-danger'>*</span>
                    </label>
                    <input className={this.state.alamat.length === 0 ? "form-control m-input border-red" : "form-control m-input"}  type="text" name="alamat" onChange={(e) => this.on_input_change(e)}
                        value={this.state.alamat} style={input_text_style}/>
                </div>
                <div className="form-group" style={{marginTop: 15+'px'}}>
                    <label style={label_input_style}>
                        Kode Pos: <span className='text-danger'>*</span>
                    </label>
                    <input className={this.state.kode_pos.length === 0 ? "form-control m-input border-red" : "form-control m-input"}  type="text" name="kode_pos" onChange={(e) => this.on_input_change(e)}
                        value={this.state.kode_pos} style={input_text_style}/>
                <span className='small text-danger'>ket : * wajib diisi / dilengkapi</span>
                </div>
                <div className="m-login__form-action" style={{marginTop: '5%',display: 'inline-block',textAlign: 'center',width: 100+'%'}}>
                    <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                    onClick={() => this.on_btn_submit_profile()} id="m_login_signin_submit" 
                    className={this.state.flag_processing ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"}>
                        Submit
                    </button> 
                    {/* <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                    onClick={() =>this.req_auto_approval()} id="m_login_signin_submit" 
                    className={this.state.flag_processing ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"}>
                        Auto Approval
                    </button>
                    <button style={{padding: '1.4rem 4rem'}} type="button" disabled={this.state.flag_processing} 
                    onClick={() => this.req_manual_approval()} id="m_login_signin_submit" 
                    className={this.state.flag_processing ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"}>
                        Manual Approval
                    </button> */}
                </div>
                {this.state.show_email_token? <EmailVerification data={{user_id: self.props.user_id,email:this.state.email,callback:self.on_profile_callback, on_close: ()=>{
                    self.setState({show_email_token: false})
                }}}/> : ''}
            </div>
             
        )
    }
}

class AgentRegister extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 'init-form',
            flag_processing: false,
            username: "",
            user_id: "",
            token: ""
        }
        this.register_agent = this.register_agent.bind(this)
        this.on_btn_submit_init_callback = this.on_btn_submit_init_callback.bind(this)
        this.on_btn_submit_verification_callback = this.on_btn_submit_verification_callback.bind(this)
        this.on_btn_submit_create_callback = this.on_btn_submit_create_callback.bind(this)
        this.on_btn_submit_profile_callback = this.on_btn_submit_profile_callback.bind(this)
    }
    



    register_agent(param) {
        let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
        let master_agent = param.master
        if (param.master.length === 0) {
            master_agent = config.master_referal_default
        }
        let body = {
            "white_label_id" : whitelabel_36,
            "master_agent_id" : master_agent,
            "username" : param.username,
            "password": param.password,
            "verification_type" : verification_provider,
            "language" : "en",
            "platform" : "WEB"
        }
        let self = this
        request.post(apis.register_agent)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    swal("Ups!", "Register error", "warning")
                } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                            self.setState({user_id: payload.results.user_id, username: payload.results.username}, () => {
                                self.verify_agent()
                            })
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })
    }

    verify_agent() {
        let body = {
            "user_id" : this.state.user_id,
            "verification_type" : verification_provider,
            "verification_code" : this.state.token
        }
        let self = this
        request.post(apis.verification_code)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    swal("Ups!", "Register error", "warning")
                } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                            self.setState({page: 'profile-form', user_id: self.state.user_id, username: self.state.username})
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    }
                }
            })
    }

    request_approval() {
        let body = {
            "user_id" : this.state.user_id,
            "auto_approve": true,
            "auto_login" : true
        }
        request.post(apis.request_approval)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res != undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status === "OK") {
                            swal("Selamat!", payload.display_message, "warning").then((value) => {
                                setTimeout(() => {
                                    history.replace("/login")
                                }, 500)
                            })
                        } else {
                            message_result = {title: "Error", body: res.body.error.message}
                            if (res.body.display_message !== undefined) {
                                message_result = {title: res.body.error.message, body: res.body.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                }
                if (message_result.length !== 0) {
                    swal(message_result.title, message_result.body, "warning")
                }
            })
    }

    on_btn_submit_init_callback(result) {
        util.log("on_btn_submit_init_callback", result)
        if (result !== undefined) {
            if (result.code === 200) {
                this.setState({page: 'create-form', username: result.username, token: result.token})
            } else if (result.code === 201) {
                this.setState({page: 'profile-form', username: result.username, user_id: result.user_id})
            }
        }
    }

    on_btn_submit_verification_callback(result) {
        util.log("on_btn_submit_verification_callback", result)
        this.setState({page: 'create-form'})
    }

    on_btn_submit_create_callback(result) {
        util.log("on_btn_submit_create_callback", result)
        this.register_agent(result)
    }

    on_btn_submit_profile_callback(result) {
        util.log("on_btn_submit_profile_callback", result);
        this.setState({page: 'profile-form',username: result.username, user_id: result.user_id})

        // if (result.code === 200) {
        //     this.request_approval()
        // }
    }

    render() {
        let self = this
        const input_text_style = {padding: '1rem',fontSize: 20+'px'}
        let current_page = '';

        if (this.state.page === 'init-form') {
            current_page = <AgentRegister_1 next={this.on_btn_submit_init_callback}/>
        } else if (this.state.page === 'verification-form') {
            current_page = <AgentRegister_2 next={this.on_btn_submit_verification_callback}/>
        } else if (this.state.page === 'create-form') {
            current_page = <AgentRegister_3 next={this.on_btn_submit_create_callback} username={this.state.username}/>
        } else if (this.state.page === 'profile-form') {
            current_page = <AgentRegister_4 next={this.on_btn_submit_profile_callback} username={this.state.username} user_id={this.state.user_id} />
            // current_page = <AgentRegister_4 username={this.state.username} user_id={this.state.user_id} />
        }

        return (
            <div className="m-grid m-grid--hor m-grid--root m-page">
                <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2" id="m_login" style={{backgroundImage: "url(swipe/assets/app/media/img/bg/bg-3-optimized.jpg)"}}>
                    <div className="m-grid__item m-grid__item--fluid m-login__wrapper" style={{paddingTop: 30+'px'}}>
                        <div className="" style={{margin: '20px 0 20px 0'}}>
                            <div className="m-login__logo" style={{margin: '0 auto 0rem auto',textAlign: 'center'}}>
                                <img style={{width:'300px',height:'auto',marginBottom:'10px',display:'block',margin:'auto'}} src={PospayLogo} />
                            </div>
                            <div className="" style={{marginTop:'15px',width:'700px'}}>
                                <div className="m-login__head">
                                    <h3 className="" style={{color: '#9e97aa',textAlign: 'center',fontSize: '1.5rem'}}>
                                        Register Jadi POSPAY Agen
                                    </h3>
                                </div>
                                <div className="m-portlet" style={{padding: 40+'px',marginTop: 40+'px'}}>
                                    {current_page}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
export default AgentRegister